// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentEditModal__O76NV {
  width: 696px;
  height: 447px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__aiDTA {
  height: 100%;
  padding: 25px 25px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  row-gap: 5px;
}

.modalFooter__ZKV6j {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  padding: 0 25px 25px;
}

.twoParts__tmUHJ {
  display: grid;
  align-items: flex-start;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
}

.equipmentInfo__m0HJ2 {
  display: grid;
  align-items: flex-end;
  grid-template-columns: auto 110px;
  column-gap: 20px;
}

.equipmentStatus__rXhbo {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  padding-top: 3px;
  padding-bottom: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid;
  align-self: center;
}

.activeStatus__tuD98 {
  border-color: var(--labels-outline-stroke-text-success);
  color: var(--labels-outline-stroke-text-success);
}

.inactiveStatus__pWJ8n {
  color: var(--labels-filled-surface-critical);
  border-color: var(--labels-filled-surface-critical);
}

.scheduledStatus__bngSt {
  color: var(--labels-filled-surface-standard);
  border-color: var(--labels-filled-surface-standard);
}

.fieldLabel__J_lmh {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 7px;
  padding-right: 17px;
}

.infoIcon__KLuTB {
  outline: none;
  margin-top: -2px;
}

.deactivationDate__HhzoQ {
  display: flex;
  align-items: center;
  column-gap: 16px;
  padding: 9px 15px 7px;
  color: var(--inputs-disable-text);
  border: unset;
  background: var(--inputs-disable-disable-surface);
  border-radius: 5px;
}

.deactivateClock__rHOHv path {
  stroke: var(--labels-filled-surface-critical);
}

.locationSelectWrapper__QpVQM {
  position: relative;
}

.createLocBtn__iVydw {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EquipmentEditModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,qBAAA;EACA,iCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,uDAAA;EACA,gDAAA;AAzEF;;AA4EA;EACE,4CAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,4CAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iCAAA;EACA,aAAA;EACA,iDAAA;EACA,kBAAA;AAzEF;;AA8EI;EACE,6CAAA;AA3EN;;AAgFA;EACE,kBAAA;AA7EF;;AAgFA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentEditModal {\n  width: 696px;\n  height: 447px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  height: 100%;\n  padding: 25px 25px 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n  padding: 0 25px 25px;\n}\n\n.twoParts {\n  display: grid;\n  align-items: flex-start;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 20px;\n}\n\n.equipmentInfo {\n  display: grid;\n  align-items: flex-end;\n  grid-template-columns: auto 110px;\n  column-gap: 20px;\n}\n\n.equipmentStatus {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid;\n  align-self: center;\n}\n\n.activeStatus {\n  border-color: var(--labels-outline-stroke-text-success);\n  color: var(--labels-outline-stroke-text-success);\n}\n\n.inactiveStatus {\n  color: var(--labels-filled-surface-critical);\n  border-color: var(--labels-filled-surface-critical);\n}\n\n.scheduledStatus {\n  color: var(--labels-filled-surface-standard);\n  border-color: var(--labels-filled-surface-standard);\n}\n\n.fieldLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 7px;\n  padding-right: 17px;\n}\n\n.infoIcon {\n  outline: none;\n  margin-top: -2px;\n}\n\n.deactivationDate {\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n  padding: 9px 15px 7px;\n  color: var(--inputs-disable-text);\n  border: unset;\n  background: var(--inputs-disable-disable-surface);\n  border-radius: 5px;\n}\n\n.deactivateClock {\n  :global {\n    path {\n      stroke: var(--labels-filled-surface-critical);\n    }\n  }\n}\n\n.locationSelectWrapper {\n  position: relative;\n}\n\n.createLocBtn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentEditModal": `equipmentEditModal__O76NV`,
	"modalBody": `modalBody__aiDTA`,
	"modalFooter": `modalFooter__ZKV6j`,
	"twoParts": `twoParts__tmUHJ`,
	"equipmentInfo": `equipmentInfo__m0HJ2`,
	"equipmentStatus": `equipmentStatus__rXhbo`,
	"activeStatus": `activeStatus__tuD98`,
	"inactiveStatus": `inactiveStatus__pWJ8n`,
	"scheduledStatus": `scheduledStatus__bngSt`,
	"fieldLabel": `fieldLabel__J_lmh`,
	"infoIcon": `infoIcon__KLuTB`,
	"deactivationDate": `deactivationDate__HhzoQ`,
	"deactivateClock": `deactivateClock__rHOHv`,
	"locationSelectWrapper": `locationSelectWrapper__QpVQM`,
	"createLocBtn": `createLocBtn__iVydw`
};
module.exports = ___CSS_LOADER_EXPORT___;
